import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Loader } from '@sdir/sds';
import { ErrorMessage } from '@sdir/utilities/lib/components';
// eslint-disable-next-line max-len
import { HealthServiceCoreFeaturesMedicalExaminationApiModelsMedicalCertificateVerifyDto as HealthDto } from '@sdir/httpclient/lib/clients/aps/health';
import { medicalExaminationApi } from '../../../httpclient';
import { HealthDeclaration } from '../../Molecules';

const HealthPage: React.FC = () => {
  const { uid } = useParams<{ uid: string }>();
  const [searchError, setSearchError] = useState(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [health, setHealth] = useState<HealthDto>();

  useEffect(() => {
    setLoading(true);
    medicalExaminationApi
      .v1MedicalcertificateGetmedicalcertificateverificationCertificateNumberGet(uid)
      .then((response) => {
        if (response.status === 200) {
          setHealth(response.data);
        }
      })
      .catch((error) => {
        setSearchError(error);
        setHealth(undefined);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [uid]);

  return (
    <Wrapper>
      {loading && <Loader />}
      {health && <HealthDeclaration data={health} />}
      {searchError && <ErrorMessage error={searchError} />}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 2em;
`;

export default HealthPage;
